
const spoiler = document.getElementById('spoiler');
const info = document.getElementById('info');


if(spoiler) {
	spoiler.addEventListener('click', () => {
	info.classList.toggle('hidden-mob');
	})
}

